import { HttpClient } from "@angular/common/http";
import { Component, OnInit } from "@angular/core";
import { getHeadersWithToken } from "src/app/shared/helpers/getHeadersWithToken";
import { environment } from "src/environments/environment";

enum caseTitleEnum {
  divorce = "طلاق",
  futureAlimony = "نفقة مستقبلية",
  housingAllowance = "نفقة سكن",
}
@Component({
  selector: "app-reasons-cases-reports",
  templateUrl: "./reasons-cases-reports.component.html",
  styleUrls: ["./reasons-cases-reports.component.scss"],
})
export class ReasonsCasesReportsComponent implements OnInit {
  reportsCase: any[];
  isLoading = false;
  platte = [
    {
      id: 1,
      color: "rgba(15, 153, 109, 0.24)",
    },
    {
      id: 2,
      color: "rgba(229, 109, 189, 0.24)",
    },
    {
      id: 3,
      color: "rgba(255, 197, 0,0.24)",
    },
    {
      id: 4,
      color: "rgba(27, 77, 172, 0.24)",
    },
    {
      id: 5,
      color: "rgba(210, 17, 17, 0.24)",
    },
    {
      id: 6,
      color: "rgba(112, 112, 112, 0.24)",
    },
    {
      id: 7,
      color: "rgba(173, 222, 5, 0.24)",
    },
    {
      id: 8,
      color: "rgba(163, 90, 11, 0.24)",
    },
    {
      id: 9,
      color: "rgba(255, 225, 130, 0.24)",
    },
    {
      id: 10,
      color: "rgba(108, 58, 175, 0.24)",
    },
    {
      id: 11,
      color: "rgba(132, 233, 201, 0.24)",
    },
    {
      id: 12,
      color: "rgba(248, 89, 195, 0.24)",
    },
    {
      id: 13,
      color: "rgba(0, 30, 100, 0.24)",
    },
    {
      id: 14,
      color: "rgba(255, 197, 0, 0.24)",
    },
    {
      id: 15,
      color: "rgba(18, 140, 171, 0.24)",
    },
    {
      id: 16,
      color: "rgba(246, 158, 141, 0.24)",
    },
    {
      id: 17,
      color: "rgba(10, 196, 16, 0.24)",
    },
    {
      id: 18,
      color: "rgba(156, 0, 191, 0.24)",
    },
    {
      id: 19,
      color: "rgba(149, 174, 255, 0.24)",
    },
    {
      id: 20,
      color: "rgba(33, 218, 232, 0.24)",
    },
  ];
  reportsArr: any[];
  csvFileData: any = [
    [["أسباب قضايا الطلاق المنتهية", " العدد"]],
    [["أسباب قضايا النفقة المستقبلية المنتهية", " العدد"]],
    [["أسباب قضايا نفقة السكن المنتهية", " العدد"]],
  ];
  caseTitle!: string;
  caseTitleKeys = Object.keys(caseTitleEnum) as (keyof typeof caseTitleEnum)[];
  constructor(private _http: HttpClient) {}

  ngOnInit(): void {
    this.reportsCase = new Array(this.caseTitleKeys.length).fill(null); // Initialize the reportsCase array
    this.reportsArr = new Array(this.caseTitleKeys.length).fill(null); // Initialize the reportsArr array

    const promises = this.caseTitleKeys.map((key, index) => {
      return this.getReasonsCase(caseTitleEnum[key], index);
    });
    Promise.all(promises);
  }

  // fetch data from api
  async getReasonsCase(caseTitle: string, index: number) {
    this.isLoading = true;
    this.reportsCase[index] = await this._http
      .get(`${environment.apiHost}case-reasons/report?caseTitle=${caseTitle}`, {
        headers: getHeadersWithToken(),
      })
      .toPromise();
    this.isLoading = false;
    this.reportsArr[index] = JSON.parse(
      JSON.stringify(this.reportsCase[index].report)
    );
    this.addTheme(this.reportsArr[index], index);
    this.exportData();
  }

  // add color to arr
  addTheme(reports: any, index: number) {
    for (let item in this.reportsArr[index]) {
      this.csvFileData[index].push(Object.values(this.reportsArr[index][item]));
      this.reportsArr[index][item].id = +item + 1;
    }
    this.reportsArr[index].map((item: any) => {
      this.platte.map((color: any) => {
        if (item.id == color.id) {
          return (item.color = color.color);
        }
      });
    });
  }

  // export data csv
  // exportData() {
  //   let bom = new Uint8Array([0xef, 0xbb, 0xbf]);
  //   let blob = new Blob(
  //     [bom, this.csvFileData.map((items: any) => items.join("\n")).join("\n\n")],
  //     {
  //       type: "text/csv;charset=utf-8;",
  //     }
  //   );
  //   let link = document.getElementById("Link");
  //   let url = URL.createObjectURL(blob);
  //   link.setAttribute("href", url);
  //   link.setAttribute("download", "إحصائيات أسباب القضايا" + ".csv");
  // }

  exportData() {
    const bom = new Uint8Array([0xef, 0xbb, 0xbf]);
    const csvRows: string[] = [];

    const tabTitles = [
      "أسباب قضايا الطلاق المنتهية",
      "أسباب قضايا النفقة المستقبلية المنتهية",
      "أسباب قضايا نفقة السكن المنتهية",
    ]; 

    for (let tabIndex = 0; tabIndex < this.csvFileData.length; tabIndex++) {
      const tabData = this.csvFileData[tabIndex];

      if (!Array.isArray(tabData)) continue;

      // Section title
      csvRows.push(`\n"${tabTitles[tabIndex]}"`);

      // Determine max subreasons for header
      const maxSubreasons = Math.max(
        ...tabData
          .slice(1)
          .map((row: any[]) => (Array.isArray(row[3]) ? row[3].length : 0))
      );

      // Header row (no ID)
      const header = ["السبب الرئيسي", "العدد"];
      for (let i = 1; i <= maxSubreasons; i++) {
        header.push(`سبب فرعي ${i}`, `عدد ${i}`);
      }
      csvRows.push(header.join(","));

      // Rows
      for (let i = 1; i < tabData.length; i++) {
        const row = tabData[i];
        const reason = `"${row[1]}"`;
        const count = row[2];
        const subreasons = Array.isArray(row[3]) ? row[3] : [];

        const subreasonData = subreasons.map((sr: any) => {
          const name =
            typeof sr === "object"
              ? `"${sr.name || sr.title || ""}"`
              : `"${sr}"`;
          const srCount = typeof sr === "object" ? sr.count ?? "" : "";
          return [name, srCount];
        });

        while (subreasonData.length < maxSubreasons * 2) {
          subreasonData.push([""], [""]);
        }

        const csvLine = [reason, count, ...subreasonData].join(",");
        csvRows.push(csvLine);
      }
    }

    const blob = new Blob([bom, csvRows.join("\n")], {
      type: "text/csv;charset=utf-8;",
    });

    const link = document.getElementById("Link");
    const url = URL.createObjectURL(blob);
    link.setAttribute("href", url);
    link.setAttribute("download", "إحصائيات أسباب القضايا.csv");
  }
}
